import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class CalculatorCacheItem extends BaseModel {
  cacheKey: string;

  constructor(model: Partial<CalculatorCacheItem> = {}) {
    super();

    this.cacheKey = model.cacheKey;
  }
}
